import { Component, Input, OnInit } from '@angular/core';

// Interfaces
import { ICliente } from 'src/app/interfaces/cliente';

// Servicios
import { ClientesService } from 'src/app/services/datos/clientes.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { AvisosService } from 'src/app/services/datos/avisos.service';

// Libs
import Swal from 'sweetalert2';

@Component({
  selector: 'app-botonera',
  templateUrl: './botonera.component.html',
  styleUrls: ['./botonera.component.scss']
})
export class BotoneraComponent implements OnInit {
  @Input() cliente: ICliente = {};
  @Input() loading: boolean = false;
  @Input() activeTab: string = 'datos';

  constructor(
    private clienteSrv: ClientesService,
    private notificacionesSrv: NotificacionesService,
    private avisoCliSrv: AvisosService
  ) { }

  ngOnInit(): void {
  }


  // Archivar / Desarchivar cliente
  archivarClick() {
    console.log('__archivarClick()', this.cliente);
    const archivado = this.cliente.archivado;

    if (archivado) {
      const apiData = {
        ...this.cliente,
        archivar: false,
      };
      this.clienteSrv.archivar(apiData).subscribe((resp) => {
        this.loading = false;
        if (resp.error) {
          this.notificacionesSrv.aviso('error', resp.mensaje);
          console.log(resp.mensaje);
          return;
        }
        this.notificacionesSrv.aviso(
          'info',
          `El cliente ${this.cliente.nombre} ha sido restaurado`
        );
        this.cliente.archivado = '';
        // this.router.navigateByUrl(`panel/clientes_lista`);
      });
      return;
    }

    if (!archivado) {
      Swal.fire({
        title: '¿Archivar Cliente?',
        icon: 'question',
        html: `El cliente se archivará y dejará de estar disponible en los desplegables temporalmente.`,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si',
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;

          const apiData = {
            ...this.cliente,
            archivar: true,
          };
          this.clienteSrv.archivar(apiData).subscribe((resp) => {
            console.log('__archivarClick() resp:', resp);
            this.loading = false;
            if (resp.error) {
              this.notificacionesSrv.aviso('error', resp.mensaje);
              console.log('__archivarClick() resp.mensaje:', resp.mensaje);
              return;
            }
            this.notificacionesSrv.aviso(
              'warning',
              `El cliente ${this.cliente.nombre} ha sido archivado`
            );
            //   this.router.navigateByUrl(`panel/clientes_lista`);
            this.cliente.archivado = '1';
          });
        }
      });
      return;
    }
  }



  // Enviar aviso al cliente

  async modalAvisoCli(cliente: ICliente) {
    console.log('__craAvisoCli()', cliente);

    const mensaje = await Swal.fire({
      title: `Mandar notificación a ${cliente.nombre}`,
      html: `<span style="font-size: smaller;"> <i class="fa-solid fa-laptop"></i> Recibirá un aviso mediante la intranet del cliente </span>`,
      input: 'textarea',
      inputPlaceholder: 'Máximo 255 caracteres...',
      inputAttributes: {
        maxlength: '255',
      },
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
      inputValidator: (value) => {
        if (!value) {
          return 'Debes entrar algún texto';
        }
        if (value.length > 255) {
          return 'El texto no puede exceder los 255 caracteres';
        }
        return null;
      },
    });

    if (mensaje.isConfirmed && mensaje.value) {
      // Llamar al servicio con el texto value

      const data = {
        id_cliente: cliente.id,
        tipo: '1',
        buscar_pedido: null,
        mensaje: mensaje.value,
      };

      this.loading = true;
      this.avisoCliSrv.avisoNew(data).subscribe((resp) => {
        this.loading = false;
        if (resp.error) {
          this.notificacionesSrv.aviso('error', resp.mensaje);
          return;
        }
        console.log(resp);
        this.notificacionesSrv.aviso('success', resp.mensaje);
      });
    }
  }


}
